export default function initPrototypes() {

	/**
	 * Checks if a string is a valid email address
	 * @return {boolean} true if the string is a valid email address, false otherwise
	 */
	String.prototype.isValidEmail = function () {
		return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this);
	}
}